import Link from '@/components/Button'
import ContactFormHeader from '@/components/ContactFormHeader'
import TaxonomyTerms from '@/components/TaxonomyTerms'
import Image from 'next/image'
import styles from './EntryHeader.module.scss'

export default function EntryHeader(props) {
  const { image, pageFields, title, form, formattedDate, isSinglePost, post, description, children, highlightWords = [] } = props
  const pageTitle = pageFields?.innerHeroFields?.title || title
  const { content, eyebrowText, includeForm, heroLink } = pageFields?.innerHeroFields || {}
  const heroLinkUrl = heroLink?.url
  const heroLinkTitle = heroLink?.title
  const heroLinkTarget = heroLink?.target
  function highlightText(text) {
    if (!text || highlightWords.length === 0) return text
    const regex = new RegExp(`\\b(${highlightWords.join('|')})\\b`, 'gi')
    return text.replace(regex, '<span class="highlighted-word">$1</span>')
  }

  const heroImage = image?.sourceUrl ? (
    <Image src={image.sourceUrl} alt={image.altText || ''} fill sizes="100vw" style={{ objectFit: 'cover', zIndex: -3 }} priority />
  ) : null

  return includeForm?.includes('include') ? (
    <div className={styles.entryHeaderForm}>
      {heroImage}
      {!props.disableOverlay && <div className={styles.overlay}></div>}
      <div className={`container ${styles.contentContainer}`}>
        <div className={styles.leftContent}>
          {eyebrowText && (
            <p className="eyebrow-text" style={{ color: 'white' }}>
              {eyebrowText}
            </p>
          )}
          <h1 className={styles.titleForm}>{pageTitle}</h1>
          {content && <p className={styles.content}>{content}</p>}
          {heroLinkUrl && (
            <Link href={heroLinkUrl} target={heroLinkTarget}>
              {heroLinkTitle}
            </Link>
          )}
        </div>
        <ContactFormHeader form={form} />
      </div>
    </div>
  ) : (
    <div className={styles.entryHeader}>
      {heroImage}
      {!props.disableOverlay && <div className={styles.overlay}></div>}
      <div className={styles.contentContainer}>
        {eyebrowText && (
          <p className="eyebrow-text" style={{ color: 'white' }}>
            {eyebrowText}
          </p>
        )}
        {/* Conditionally render TaxonomyTerms if on single post */}
        {isSinglePost && <TaxonomyTerms post={post} taxonomy={'categories'} className={styles.whiteText} />}
        <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: highlightText(pageTitle) }} />
        {formattedDate && <p className={styles.date}>{formattedDate}</p>}
        {content && <p className={styles.content}>{content}</p>}
        {description && <p className={styles.content}>{description}</p>}
        {children}
        {heroLinkUrl && (
          <Link className={styles.heroLink} href={heroLinkUrl} target={heroLinkTarget}>
            {heroLinkTitle}
          </Link>
        )}
      </div>
    </div>
  )
}
